import script from "./SplitLayoutFeatureSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitLayoutFeatureSection.vue?vue&type=script&setup=true&lang=ts"

import "./SplitLayoutFeatureSection.vue?vue&type=style&index=0&id=312c511e&lang=scss"

const __exports__ = script;

export default __exports__